import { render, staticRenderFns } from "./BoardIcon.vue?vue&type=template&id=133f924a&scoped=true&"
import script from "./BoardIcon.vue?vue&type=script&lang=js&"
export * from "./BoardIcon.vue?vue&type=script&lang=js&"
import style0 from "./BoardIcon.vue?vue&type=style&index=0&id=133f924a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f924a",
  null
  
)

export default component.exports